var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCloseCircled = function SvgIconCloseCircled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.333 5.667a.583.583 0 0 0-.825 0L8 7.175 6.492 5.667a.583.583 0 0 0-.825.825L7.175 8 5.667 9.508a.583.583 0 0 0 .825.825L8 8.825l1.508 1.508a.583.583 0 0 0 .825-.825L8.825 8l1.508-1.508a.583.583 0 0 0 0-.825"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 1a7 7 0 1 0 7 7 7.007 7.007 0 0 0-7-7m0 12.833A5.833 5.833 0 1 1 13.833 8 5.84 5.84 0 0 1 8 13.833"
  })));
};
export default SvgIconCloseCircled;